module.exports = __webpack_public_path__ + "static/media/marker.177b7c47.png";